<template>
  <div>
    <b-checkbox v-if="disk_list && disk_list.length > 0" v-model="hide_docker_overlay">
      <span v-b-tooltip.hover.right title="Sets whether the docker shows the container path (lib, container, etc)">
        Docker Volumes Hide
        <span>
          <i style="cursor:pointer" class="fas fa-question-circle"></i>
        </span>
      </span>
    </b-checkbox>

    <b-checkbox v-if="disk_list && disk_list.length > 0" :disabled="os_type != 'linux'" v-model="show_permission">
      <span v-b-tooltip.hover.right title="Displays permission information for a folder The experimental function is a beta function that can disappear at any time">
        Show Permissions (Experimental Features)
        <span class="text-info">
          <i style="cursor:pointer" class="fas fa-question-circle"></i>
        </span>
      </span>
    </b-checkbox>

    <hr v-if="disk_list && disk_list.length > 0">
    <b-row v-if="hide_docker_overlay == false || (hide_docker_overlay && (d.mountpoint.indexOf('docker/overlay') < 0 && d.mountpoint.indexOf('docker/containers') < 0 && d.mountpoint.indexOf('docker/volumes') < 0))" v-for="(d, index) in disk_list" v-bind:key="index" class="animated fadeIn fadeOut">
      <b-col sm="2">
        {{d.used}} / {{d.total}}
      </b-col>
      <b-col sm="1">
        {{d.percent}}
      </b-col>
      <b-col>
        <b-progress :max="100" height="1.1rem">
          <b-progress-bar :value="Number(d.percent.replace('%', ''))">
            <span class="ml-5 mr-5 text-dark">{{d.mountpoint}}</span>
          </b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <hr v-if="disk_list && disk_list.length > 0">
    <b-button class="btn-add" v-if="show && only_view != true" block href="#" variant="success" @click="$parent.$emit('save')">Save</b-button>
    <!-- @dragstart="dragstart($event, item)" -->
    <!-- @drag="ondrag($event, item)" -->
    <b-card-group v-if="show && item.length"
      style="height:fit-content"
      @dragend="dragend($event, item)"
      @drop="drop($event, item)"
      @dragover="dragover($event, item)"
      @dragenter="dragenter($event, item)"
      @dragleave="dragleave($event, item)"
    >
      <!-- 대상 설정 -->
      <b-card style="border-radius: 5px;">
        <i class="float-right fa fa-refresh" @click="refresh" style="cursor: pointer;"></i>
        <folder
          @dragstart_custom="($event, item) => dragstart($event, item)"
          @add_white_list="x => $parent.$emit('add_white_list', x)"
          @add_white_list_file="x => $parent.$emit('add_white_list_file', x)"
          @add_scan_list="x => $parent.$emit('add_scan_list', x)"
          v-for="child in item" :item="child" :key="child.id" @path="get_path"
          :show_permission="show_permission"
          :msg_uid="'Highlighted in red if UID is root'"
          :msg_gid="'If the GID is root, it is highlighted in red'"
          :msg_sticky="'Sticky bit is set'"
        />
      </b-card>
      <!-- 설정된 대상 -->
      <b-card class="w-50" style="height:fit-content; border-radius: 5px;">
        <div class="dropzone_path_scan_list" style="border-radius: 5px; min-height: 35%; z-index:-100; width:100%; padding : 5px;">
          <p class="w-100 text-center font-weight-bold">
            <span v-b-tooltip.hover title="Specify the monitored folder For Web shell detection solutions, we recommend setting it as an upload folder or a web folder For forgery settings, for forgery monitoring, the settings and backup folders are recommended">
              * Monitoring Folder
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </span>

            (<b-button size="sm" variant="link" @click="modal_scan_list_history = true">prevoius history</b-button>)
            <b-button size="sm" class="float-right" :disabled="scan_list.length == 0" variant="warning" @click="$parent.$emit('clear', 'scan_list')">Clear</b-button>
          </p>
          <hr>
          <div style="width: fit-content;" v-for="(s, index) in scan_list" :value="s" :key="'scan_list_'+index" :item="s">
            <b-button size="sm" variant="danger" @click="$parent.$emit('remove', 'scan_list', s)">X</b-button> {{s}} <br />
          </div>
        </div>
        <br>
        <!-- 예외 폴더 -->
        <div class="dropzone_path_white_list" style="border-radius: 5px; min-height: 35%; z-index:-100; width:100%; padding : 5px;">
          <p class="w-100 text-center font-weight-bold">
            <span v-b-tooltip.hover title="Specifies the part to handle exceptions This part is not detected">
              Exception Folder <span v-if="white_file_active != true"> or File </span>
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </span>
            <b-button size="sm" class="float-right" :disabled="!white_path || white_path.length == 0" variant="warning" @click="$parent.$emit('clear', 'white_path')">Clear</b-button>
          </p>
          <hr>
          <div style="width: fit-content;" v-for="(s, index) in white_path" :value="s" :key="'white_path_'+index" :item="s">
            <b-button size="sm" variant="danger" @click="$parent.$emit('remove', 'white_path', s)">X</b-button> {{s}} <br />
          </div>
          <hr>
          <b-input-group>
            <b-form-input class="white_path_one" type="text" @keyup.enter="add_white_list_custom" v-model="input_custom_1" :placeholder="`Ex) ${scan_list.length > 0 ? scan_list[0]+( scan_list[0].indexOf('/') > -1 ? '/' : '\\' )+'white_file_target' : '/var/www/html/upload/backup'}`"></b-form-input>
            <b-button class="btn-addition" variant="primary" @click="add_white_list_custom">Add</b-button>
          </b-input-group>
        </div>
        <br>
        <div v-if="white_file_active == true" class="dropzone_path_white_list_file" style="border-radius: 5px; min-height: 35%; z-index:-100; width:100%; padding : 5px;">
          <p class="w-100 text-center font-weight-bold">
            <span v-b-tooltip.hover title="Specifies a file to be handled for exceptions; no such file is detected">
              Exception File
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </span>
            <b-button size="sm" class="float-right" :disabled="!white_file || white_file.length == 0" variant="warning" @click="$parent.$emit('clear', 'white_file')">Clear</b-button>
          </p>
          <hr>
          <div style="width: fit-content;" v-for="(s, index) in white_file" :value="s" :key="'white_file_'+index" :item="s">
            <b-button size="sm" variant="danger" @click="$parent.$emit('remove', 'white_file', s)">X</b-button> {{s}} <br />
          </div>
          <!-- 예외 폴더는 파일도 입력이 가능해야 함 -->
          <!-- 여기서는 기존 사용하는 경로인지 확인 필요 -->
        </div>
        <hr v-if="white_file_active == true">
        <b-input-group v-if="white_file_active == true">
          <b-form-input class="white_path_file" type="text" @keyup.enter="add_white_file_custom" v-model="input_custom_2" :placeholder="`Ex) ${scan_list.length > 0 ? scan_list[0]+( scan_list[0].indexOf('/') > -1 ? '/' : '\\' )+'white_file_target' : '/var/www/html/upload/backup'}`"></b-form-input>
          <b-button class="btn-addition" variant="primary" @click="add_white_file_custom">Add</b-button>
        </b-input-group>
      </b-card>

    </b-card-group>
    <b-button class="font-weight-bold fadeIn fadeOut pulse" v-if="item.length == 0 && is_refresh" block @click="refresh" style="height:80px;">Refresh</b-button>
    <b-card v-if="item.length == 0 && is_refresh != true" class="text-center">
      <span>Failed to load folder list from agent, Please check the agent online status </span>
    </b-card>
    <b-modal title="Scan path history"  class="modal-info" v-model="modal_scan_list_history" @ok="modal_scan_list_history = false" ok-only header-bg-variant="info" ok-variant="info">
      <p v-if="!scan_list_history || !scan_list_history.length">no have previous data</p>
      <table v-else>
        <thead class="text-center font-weight-bold">
          <tr>
            <td>
              DateTime
            </td>
            <td>
              Folder List
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in scan_list_history" v-bind:key="index" style="border-top: 1px solid gray;">
            <td class="text-center" style="width: 40%">
              {{x.updated_at | sdate}}
            </td>
            <td>
              <p class="m-1" v-for="(y, index) in x.target_sub">{{y}}</p>
              <!-- TODO : 향후 이전 기록 바로 적용 추가 될 수 있음 -->
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<style>
  .pulse {
  cursor: pointer;
  box-shadow: 0 0 0 rgba(204,169,44, 0.4);
  animation: pulse 2s infinite;
}
.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
    box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
      box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
      box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
</style>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
